export function getYandexMapPreview(coordinates: { lat: number; lng: number }) {
  const { lat, lng } = coordinates;

  return `https://static-maps.yandex.ru/1.x/?ll=${lng},${lat}&z=16&l=map`;
}
